export const APP = 'APP';
export const MOBILE = 'MOBILE';